var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9303 12.1892V8.68921M9.18034 10.4392H12.6803M6.84701 8.68921H4.51367C3.42647 8.68921 2.88288 8.68921 2.45408 8.86682C1.88235 9.10364 1.42811 9.55788 1.19129 10.1296C1.01367 10.5584 1.01367 11.102 1.01367 12.1892M8.88867 1.85882C9.74379 2.20496 10.347 3.04331 10.347 4.02254C10.347 5.00178 9.74379 5.84012 8.88867 6.18627M7.722 4.02254C7.722 5.31121 6.67734 6.35588 5.38867 6.35588C4.10001 6.35588 3.05534 5.31121 3.05534 4.02254C3.05534 2.73388 4.10001 1.68921 5.38867 1.68921C6.67734 1.68921 7.722 2.73388 7.722 4.02254Z",
    stroke: "#5C4BAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralsIcon);
export default __webpack_public_path__ + "static/media/referralsIcon.cf61a7bfdd45b6f5755e39a375b55a2d.svg";
export { ForwardRef as ReactComponent };